import React, { useState } from "react";
import { Input, Button, message, Typography } from "antd";
import axios from "axios";
import { useNavigate, useLocation } from "react-router-dom";
import { useEffect } from "react";
import { useTranslation } from 'react-i18next';

const { Title, Paragraph } = Typography;

const VerifyResetCode = () => {
    const { t } = useTranslation(); // i18n fonksiyonu
    const navigate = useNavigate();
    const location = useLocation();
    const emailFromState = location.state?.email;
    const [email, setEmail] = useState(emailFromState || "");
    const [code, setCode] = useState("");
    const apiUrl = process.env.REACT_APP_API_URL;

  useEffect(() => {
    if (!emailFromState) {
      navigate("/forgot-password");
    } else {
      setEmail(emailFromState); // email input'ını doldur
    }
  }, []);

  const handleVerify = async () => {
    try {
      await axios.post(`${apiUrl}/api/Suppliers/verify-reset-code`, { email, code });
      message.success(t('verify_code_success'));
      navigate("/reset-password", { state: { email } });
    } catch (error) {
      message.error(t('verify_code_error'));
    }
  };

  return (
    <div style={pageStyle}>
      <div style={formStyle}>
        <Title level={3}>{t('verify_reset_code_title')}</Title>
        <Paragraph>{t('verify_reset_code_description')}</Paragraph>

        <Input
          placeholder={t('verify_reset_email_placeholder')}
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          style={{ marginBottom: 12 }}
        />

        <Input
          placeholder={t('verify_reset_code_placeholder')}
          value={code}
          onChange={(e) => setCode(e.target.value)}
          maxLength={4}
          style={{ marginBottom: 16 }}
        />

        <Button type="primary" block onClick={handleVerify} disabled={!email || !code}>
          {t('verify_continue_button')}
        </Button>
      </div>
    </div>
  );
};

export default VerifyResetCode;

const pageStyle = {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "100vh",
    backgroundColor: "#f5f5f5",
  };
  
  const formStyle = {
    width: "100%",
    maxWidth: "400px",
    padding: "32px",
    backgroundColor: "#fff",
    borderRadius: "8px",
    boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
  };